import './MeterBarLayout.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var chartContainer = '_1m3udw19-3-12-1';
export var container = _7a468({defaultClassName:'_1m3udw1b-3-12-1',variantClassNames:{autoSize:{true:'_1m3udw1c-3-12-1',false:'_1m3udw1d-3-12-1'},showLoading:{true:'_1m3udw1e-3-12-1'}},defaultVariants:{},compoundVariants:[]});
export var containerWrapper = '_1m3udw1f-3-12-1';
export var labelContainer = '_1m3udw18-3-12-1';
export var legendContainer = '_1m3udw17-3-12-1';
export var maxContainer = '_1m3udw16-3-12-1';
export var minContainer = '_1m3udw15-3-12-1';
export var thresholdsContainer = '_1m3udw1a-3-12-1';
export var toolbarAnimatedContainer = '_1m3udw14-3-12-1';
export var valueAnimatedContainer = '_1m3udw13-3-12-1';
export var valueContainer = _7a468({defaultClassName:'_1m3udw10-3-12-1',variantClassNames:{inline:{true:'_1m3udw11-3-12-1',false:'_1m3udw12-3-12-1'}},defaultVariants:{},compoundVariants:[]});